

import { lazy } from "react";
import temaClaro from "./temaClaro.js";
import temaOscuro from "./temaOscuro.js";

// Paginas
const Home = lazy(() => import("../pages/Home"));
const Rutas = lazy(() => import("../pages/Rutas"));
const Precios = lazy(() => import("../pages/Precios"));
const Login = lazy(() => import("../pages/Login"));
const Planeacion = lazy(() => import("../pages/Planeacion"));
const Salida = lazy(() => import("../pages/Salida"));
const Operacion = lazy(() => import("../pages/Operacion"));
const Llegada = lazy(() => import("../pages/Llegada"));
const Factura = lazy(() => import("../pages/Factura"))
const Gastos = lazy(() => import("../pages/Gastos"))
const Recargas = lazy(() => import("../pages/Recargas"))
const Inventario = lazy(() => import("../pages/LineaDeTiempo.jsx"))
const PreciosCalientes = lazy(() => import("../pages/PreciosCalientes"))
const ClienteFormulario = lazy(() => import("../pages/ClienteFormulario.jsx"))
const Metricas = lazy(() => import("../pages/Metricas"))
const Repositorio = lazy(() => import("../pages/Repositorio.jsx"));
const SelectClient = lazy(() => import("../pages/SelectClient.jsx"));
// const RutasCasas = lazy(() => import("../pages/RutasCasas.jsx"));
// const PreciosLogged = lazy(() => import("../pages/PreciosLogged"));


export const generatePaths = (logged, theme) => {

    const roles = logged?.roles ? logged.roles : [];
    const state = logged?.state ? logged.state : false;

    const pathsBase = [
        { label: "home", path: "/home", render: <Home /> },
        { label: "precios", path: "/precios", render: roles.includes('admin') ? <PreciosCalientes /> : <Precios /> },
        { label: "login", path: "/login", render: <Login theme={theme === 'light' ? temaClaro : temaOscuro} /> },
        { label: "rutas", path: "/rutas", render: <Rutas /> },
        { label: "salida", path: "/salida", render: state ? <Salida /> : <Home /> },
        { label: "llegada", path: "/llegada", render: state ? <Llegada /> : <Home /> },
        { label: "factura", path: "/factura", render: state ? <Factura /> : <Home /> },
        { label: "gastos", path: "/gastos", render: state ? <Gastos /> : <Home /> },
        { label: "recargas", path: "/recargas", render: state ? <Recargas /> : <Home /> },
        { label: "linea de tiempo", path: "/lineadetiempo", render: state ? <Inventario /> : <Home /> },
        { label: "clientela", path: "/clientela", render: state ? <ClienteFormulario /> : <Home /> },
        { label: "planeacion", path: "/planeacion", render: state ? <Planeacion /> : <Home /> },
        { label: "metricas", path: "/metricas", render: state ? <Metricas /> : <Home /> },
        { label: "repositorio", path: "/repositorio", render: state ? <Repositorio /> : <Home /> },
        { label: "buscar", path: "/buscar", render: state ? <SelectClient /> : <Home /> },
        { label: "operacion", path: "/operacion", render: state ? <Operacion /> : <Home /> },
        // { label: "rutas en casas", path: "/rutasencasas", render: state ? <RutasCasas /> : <Home /> },
    ]

    const labelsCliente = ["home", "rutas", "login"];
    const labelsTrabajador = ["home", "salida", "llegada", "planeacion", "linea de tiempo", "buscar", "recargas", "gastos", "factura", "repositorio", "operacion"];
    const labelsConductor = ["home", "salida", "llegada", "planeacion", "linea de tiempo", "buscar", "recargas", "gastos", "factura", "repositorio", "operacion"];
    const labelsAlmacenista = ["home", "precios", "rutas", "salida", "llegada", "factura", "buscar", "gastos", "recargas", "linea de tiempo", "clientela", "metricas", "operacion"];
    const labelsAdmin = [...labelsAlmacenista, "planeacion", "repositorio", "operacion"];


    const paths = () => {
        const base = labelsCliente.map(label => pathsBase.find(obj => obj.label === label));

        if (roles.includes('admin')) {
            return base.concat(
                labelsAdmin.map(label => pathsBase.find(obj => obj.label === label))
            );
        }

        if (roles.includes('trabajador')) {
            return base.concat(
                labelsTrabajador.map(label => pathsBase.find(obj => obj.label === label))
            );
        }

        if (roles.includes('conductor')) {
            return base.concat(
                labelsConductor.map(label => pathsBase.find(obj => obj.label === label))
            );
        }

        if (roles.includes('almacenista')) {
            return base.concat(
                labelsAlmacenista.map(label => pathsBase.find(obj => obj.label === label))
            );
        }

        return base;
    }

    const labels = () => ({
        noLogged: labelsCliente,

        logged: [
            roles.includes('trabajador')
                ? labelsTrabajador
                : [],

            roles.includes('conductor')
                ? labelsConductor
                : [],

            roles.includes('almacenista')
                ? labelsAlmacenista
                : [],

            roles.includes('admin')
                ? labelsAdmin
                : [],
        ].flat()
    })

    return {
        paths: paths(),
        labels: labels()
    }
}